<template>
    <div class="template-card-v2-attachment--item__container">
        <!-- NAME -->
        <ObjectLink :label="relatedName" :link="linkName" :icon="icon" size="small" />

        <!-- PHONE -->
        <template v-if="clipboardPhoneEnabled">
            <InteractiveInfo v-if="item.tel" type="phone" :values="[item.tel]" size="extra-small" />

            <InteractiveInfo
                v-if="item.mobile"
                type="mobile"
                :values="[item.mobile]"
                size="extra-small"
            />
        </template>

        <!-- EMAIL -->
        <InteractiveInfo
            v-if="item.email && clipboardEmailEnabled"
            type="email"
            :values="[item.email]"
            size="extra-small"
            @sendEmail="handleSendEmail"
        />
    </div>
</template>

<script>
import EmailMixins from '../../mixins/EmailMixins';
import AvatarMixins from '../../mixins/AvatarMixins';
import InteractiveInfo from 'vcomponents/common/InteractiveInfo.vue';
import ObjectLink from 'vcomponents/common/object/ObjectLink.vue';

export default {
    components: {
        InteractiveInfo,
        ObjectLink,
    },
    mixins: [EmailMixins, AvatarMixins],
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            linkedtype: null,
            linkedid: null,
        };
    },

    computed: {
        icon() {
            switch (this.item.type) {
                case 'opportunity':
                    return 'nav-opportunity';
                case 'prospect':
                case 'supplier':
                case 'third':
                case 'client':
                    return 'company';
                case 'people':
                    return 'nav-contact';
                default:
                    return 'nav-billing';
            }
        },
        clipboardPhoneEnabled() {
            return (
                this.item?.type !== 'staff' &&
                this.item?.type !== 'owner' &&
                (this.item.tel?.length > 0 || this.item.mobile?.length > 0) &&
                !this.isBlockedOrDeleted(this.item)
            );
        },
        clipboardEmailEnabled() {
            return (
                this.item?.type !== 'staff' &&
                this.item?.type !== 'owner' &&
                this.item?.email &&
                this.item?.email.length > 0 &&
                !this.isBlockedOrDeleted(this.item)
            );
        },
        linkName() {
            return this.item.link ? this.item.link : this.getContactUrl();
        },
        relatedName() {
            return this.item.fullName ?? this.item.name;
        },
    },
    created() {
        this.linkedtype = this.item.type;
        this.linkedid = this.item.id ? this.item.id : this.item[`${this.item.type}id`];
    },
    methods: {
        handleSendEmail(email) {
            this.checkEmailProvider({}, { checkPrefill: true }, email);
        },
        getContactUrl() {
            let url = false;
            switch (this.item.type) {
                case 'people':
                    url = this.$router.resolve({
                        name: 'legacy.people.overview',
                        params: { id: this.item.peopleid },
                    }).href;
                    break;
                case 'third':
                    url = this.$router.resolve({
                        name: 'legacy.third.overview',
                        params: { thirdid: this.item.thirdid, thirdtype: this.item.relationType },
                    }).href;
                    break;
                case 'staff':
                    url = this.$router.resolve({
                        name: 'legacy.staff.overview',
                        params: { staffid: this.item.staffid },
                    }).href;
                    break;
            }
            return url;
        },
    },
};
</script>

<style lang="scss" scoped>
.template-card-v2-attachment--item__container {
    display: flex;
    gap: var(--spacing-1);
}
</style>
